export default __webpack_public_path__ + "static/media/places3.a8233e4d.jpg";